<template>
  <v-card>
    <v-form @submit.prevent="submitEditUser()" ref="editUserForm">
      <v-container grid-list-lg>
        <v-layout wrap>
          <dialog-header :title="'Edit'" :details="`${user.name} (${user.userAuthClass.name})`"></dialog-header>
          <v-flex xs12 sm6>
            <v-text-field label="* Name" v-model="editedUser.name" :rules="nameRules"></v-text-field>
          </v-flex>
          <v-flex xs12 sm6>
            <v-text-field label="* Email" v-model="editedUser.email" :rules="emailRules"></v-text-field>
          </v-flex>
          <v-flex xs12>
            <v-autocomplete
              label="* User Authorization"
              :items="userAuthClasses"
              v-model="editedUser.userAuthClassId"
              item-text="name"
              item-value="id"
              :rules="userAuthClassRules"
            ></v-autocomplete>
          </v-flex>
        </v-layout>
      </v-container>
      <v-card-actions>
        <v-spacer></v-spacer>
        <div v-if="different">
          <v-btn :color="primaryGrey" flat @click="discard()">Discard?</v-btn>
          <v-btn :color="primaryGreen" flat type="submit" :loading="loading">Save</v-btn>
        </div>
        <div v-else>
          <v-btn :color="primaryGrey" flat @click="close()">Close</v-btn>
        </div>
      </v-card-actions>
    </v-form>
  </v-card>
</template>

<script>
import Store from "@/store/computed/storeHelpers";
import UserService from "@/services/requests/userService";

// MIXINS
import UserValidation from "@/services/validation/userValidation";

// COMPONENTS
import DialogHeader from "@/components/ui/dialogHeader";

export default {
  mixins: [UserValidation],
  components: {
    DialogHeader
  },
  data() {
    return {
      editedUser: Object.assign({}, this.user),
      loading: false
      // passwordConfirmationDialog: false
    };
  },
  methods: {
    close() {
      this.$emit("close");
    },
    discard() {
      this.editedUser = Object.assign({}, this.user);
      this.close();
    },
    submitEditUser() {
      if (!this.$refs.editUserForm.validate()) {
        return;
      }
      this.save();
    },
    save() {
      this.loading = true;
      UserService.updateUser(this.editedUser)
        .then(result => {
          this.loading = false;
          this.$store.commit("users/updateArrayStateByValue", {
            prop: "users",
            value: this.user,
            editedValue: result.data.result.user
          });
          this.editedUser = Object.assign({}, result.data.result.user);
          this.snack({ color: "green", text: "User was edited" });
          this.close();
        })
        .catch(err => {
          this.loading = false;
          console.log(err);
          this.snackError();
        });
    }
  },
  computed: {
    different() {
      if (!this._.isEqual(this.user, this.editedUser)) {
        return true;
      } else {
        return false;
      }
    },
    userAuthClasses: Store.getSet({ store: "users", prop: "userAuthClasses" })
  },
  props: {
    user: Object
  },
};
</script>

<style>
</style>
